import React, { Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

import axios from 'utils/axios'
import useRouter from 'utils/useRouter';
import { logout } from 'actions';

const AuthGuard = props => {
  const { children } = props;
  
  const roles = ['1', '2', '3', '4'];
  
  const session = useSelector(state => state.session);
  const router = useRouter();
  const dispatch = useDispatch();


  useEffect(() => {
    axios.interceptors.response.use(
      response => response,
      (error) => {
        const status = error.response ? error.response.status : null
        const originalRequest = error.config
    
        if (status === 401) {
          router.history.push('/auth/login');
          dispatch(logout());
        } else {
          return Promise.reject(error)
        }
      }
    )

    if (!session.loggedIn || !session.user) {
      if(router.history.location.pathname != '/auth/login'){
        router.history.push('/auth/login');
      }
      return;
    } else if(!roles.includes(session.user.role) && router.history.location.pathname != '/errors/error-401' ) {
      router.history.push('/errors/error-401');
    } else{
      axios.defaults.headers.common['Authorization'] = `Bearer ${session.user.access_token}`;
      if(router.history.location.pathname == '/auth/login') {
        router.history.push('/');
      }
    }
    
    

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router]);

  return <Fragment>{children}</Fragment>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
  roles: PropTypes.array.isRequired
};

AuthGuard.defaultProps = {
  roles: []
};

export default AuthGuard;
